import type { SalesSampleLine } from '../../types/domain';

interface SalesSampleDetailsProps {
  samples?: SalesSampleLine[];
  label: string;
  summary?: boolean;
}

export function SalesSampleDetails({ samples = [], label, summary = false }: SalesSampleDetailsProps) {
  const grouped = new Map<string, { name: string; sku: string; quantity: number }>();
  for (const sample of samples) {
    const existing = grouped.get(sample.product_id);
    if (existing) existing.quantity += sample.quantity;
    else grouped.set(sample.product_id, {
      name: sample.product_name,
      sku: sample.product_sku,
      quantity: sample.quantity,
    });
  }
  if (grouped.size === 0) return null;

  const rows = [...grouped.entries()].sort(([, a], [, b]) => (
    a.name.localeCompare(b.name) || a.sku.localeCompare(b.sku)
  ));
  if (!summary) {
    return (
      <section aria-label={label} className="sales-product-samples">
        <p>{rows.map(([id, sample], index) => (
          <span key={id}>
            {index > 0 ? <><span aria-hidden="true" className="sales-sample-divider" /><span className="sr-only">; </span></> : null}
            {sample.name} × {sample.quantity}
          </span>
        ))}</p>
      </section>
    );
  }
  const total = rows.reduce((sum, [, sample]) => sum + sample.quantity, 0);

  return (
    <section aria-label={label} className="sales-sample-details sales-sample-summary">
      <h4>Free samples summary</h4>
      <dl>
        {rows.map(([id, sample]) => (
          <div className="sales-sample-row" key={id}>
            <dt title={sample.sku}>{sample.name}</dt>
            <dd>{sample.quantity}<span className="sr-only"> {sample.quantity === 1 ? 'sample' : 'samples'}</span></dd>
          </div>
        ))}
        <div className="sales-sample-total"><dt>Total free samples</dt><dd>{total}</dd></div>
      </dl>
      <small>Separate from paid units and sales value.</small>
    </section>
  );
}
